import Styled from 'styled-components';

const AtbdTopDropdwon = Styled.div`
    &.search-widget .ant-input-affix-wrapper {
        padding: 8px 10px;
    }
`;

export { AtbdTopDropdwon };
